export default class PasswordModel {
    public email = ''
    public password = ''
    public confirmPassword = ''
    public code = ''
}
